export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_sh.421df84970edef89.json"